import classNames from 'classnames';

import { PropsWithClassname } from '@/app/types';

import DonationFormHeading from '@/app/components/DonationForm/donationFormParts/DonationFormHeading';

interface DonationFormHeaderProps extends PropsWithClassname {
  captionAtTheTop: string;
  collectionTitle: string;
  collectionImage?: string;
  collectionLink: string;
}

const DonationFormHeader = ({
  captionAtTheTop,
  collectionImage,
  collectionTitle,
  collectionLink,
  className,
}: DonationFormHeaderProps) => {
  return (
    <div className={classNames(className, 'mb-[56px]')}>
      <span
        className={classNames(
          className,
          'w-full mb-[8px] text-center inline-block text-[10px] lg:text-[12px] font-medium uppercase tracking-[3px] leading-[24px] lg:tracking-[4.5px]',
        )}
      >
        {captionAtTheTop}
      </span>
      <DonationFormHeading href={collectionLink} className="lg:mb-[24px]">
        {collectionTitle}
      </DonationFormHeading>
      {!!collectionImage && (
        <img
          width={640}
          height={400}
          src={collectionImage}
          alt={collectionTitle}
          className="hidden xl:block w-full h-auto rounded-md"
        />
      )}
    </div>
  );
};

export default DonationFormHeader;
